import AppLogo from "@/components/AppLogo";
import { AccountBalanceDisplay } from "@/components/ui/accountBalanceDisplay/accountBalanceDisplay";
import {
	Popover,
	PopoverContent,
	PopoverTrigger,
} from "@/components/ui/popover";
import { useAuth } from "@/context/auth-context";
import { useLoaderData, useNavigate } from "@tanstack/react-router";
import { PlusIcon } from "lucide-react";
// import HomeInvite from "../../_module/home/homeInvite";
import { Button } from "../../ui/button/button";
import { InfoIcon } from "../../ui/icons";

const UnverifiedHome = () => {
	const navigate = useNavigate();
	const { user } = useAuth();
	const { name } = useLoaderData({ from: "__root__" });

	return (
		<div className="  flex flex-col items-center justify-start ">
			{/* Top Header */}
			<div className="w-full bg-primary-600 min-h-[300px] h-full text-white px-6 pt-8 pb-12 rounded-b-[2rem] relative text-center">
				<div className="flex items-center justify-center">
					<AppLogo theme="light" />
				</div>
				<div className="py-5 space-y-2">
					<h1 className="text-4xl font-bold">
						{user.first_name ? (
							<>
								Welcome,{" "}
								<span className="capitalize">
									{user.first_name.toLowerCase()}
								</span>
							</>
						) : (
							"Welcome!"
						)}
					</h1>
					<AccountBalanceDisplay className="pt-4 mt-2 text-3xl font-bold" />
					<div className="flex items-center justify-center gap-1 mt-1 text-sm text-white/80">
						Available balance
						<Popover>
							<PopoverTrigger>
								<InfoIcon className="w-6 h-6" />
							</PopoverTrigger>
							<PopoverContent align="center" className="">
								<div className="max-w-xs p-4 text-sm text-gray-800">
									The total amount in your {name} account available for
									transfers and transactions.
								</div>
							</PopoverContent>
						</Popover>
					</div>
				</div>
			</div>

			{/* Body Sections */}
			<div className="z-20 w-full max-w-sm px-4 -mt-12 space-y-4 text-center">
				{/* Unlock features card */}
				<div className="p-4 rounded-3xl bg-secondary">
					<h2 className="mb-1 text-2xl font-bold text-secondaryText">
						Unlock all features
					</h2>
					<p className="mb-6 text-sm text-secondaryText w-[65%] mx-auto">
						Please verify your ID and unlock all app features
					</p>
					<Button
						variant="secondary"
						size="compact"
						className="font-medium text-md"
						onClick={() => {
							navigate({ to: "/main/verify-identity" });
						}}
					>
						<div className="bg-primary-600 p-3 rounded-full">
							<PlusIcon className="w-4 h-4 text-darkButtonText" />
						</div>
						Verify Account
					</Button>
				</div>

				{/* Invite friends */}
				{/* <HomeInvite code={user.referral_code} />
				<div className="pt-20"></div> */}
			</div>
		</div>
	);
};

export default UnverifiedHome;
